import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class exhibitorsList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />
                <main className="main-area fix">
                    {/* breadcrumb-area */}
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                Exhibitors
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                Exhibitor List 2022
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    {/* about-area */}
                    <section className="ExhibitorsList_section">
                        <div className="container">
                            <div className="row" data-aos="fade-up" data-aos-delay={300}>
                                <div className="col-md-12 text-center">
                                    {/* <h4 class="border_title">Important Dates</h4> */}
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">
                                            {/* <p>Conference Organisation</p> */}
                                            <span className="position_relative yellow_color">
                                                Exhibitor List 2022
                                            </span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt_40" data-aos="fade-up" data-aos-delay={500}>
                                <div className="col-md-12">
                                    <div className="custom_table">
                                        <div className="hack1">
                                            <div className="hack2">
                                                <table className="table table-striped table-dark mg-b-0">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "15%" }}>EXHIBITOR TYPE</th>
                                                            <th>ORGANIZATION</th>
                                                            <th style={{ width: "15%" }}>CHAPTER NAME</th>
                                                            <th style={{ width: "10%" }}>HALL</th>
                                                            <th>STALL NUMBER</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="myTable">
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>A G BELTING PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11H24B</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>A T E ENTERPRISES PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10B8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>A.B.PLASTICS</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10G12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>A.T.E. ENTERPRISES PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A1B2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>A.T.E. ENTERPRISES PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A1B2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>A.T.E.ENTERPRISES PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A1B2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>
                                                                AADI CORPORATION BR OF SULTANPURE TEX MILLS PVT LTD
                                                            </td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AAKASH TEXTILE ENGINEERS LLP</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10E16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AALIDHRA TEXPRO ENGINEERS PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12C25D10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AALIDHRA TEXTOOL ENGINEERS PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11A11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AB CARD CLOTHING PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AB CARTER INDIA PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9H1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AB REINIGER INDUSTRIES PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10B6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ABC CORPORATION</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15J9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ABE TEX</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5H5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ABHINANDAN ENTERPRISES</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9H8A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ABHISHEK ENGINEERING WORKS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ACCORTEX</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ACCOTEX</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ACE MACHINERY CO.,LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ACTIVE INKJET SOLUTIONS</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7</td>
                                                            <td>H7L10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ADEPT ENGINEERS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ADIK CORPORATION</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5H4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ADITYA PUBLICATION</td>
                                                            <td />
                                                            <td>H11</td>
                                                            <td>H11H23A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AD-TEX ENTERPRISES</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ADVANCED GRAPHIC SYSTEMS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AB8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ADWAITH LAKSHMI INDUSTRIES PRIVATE LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10G19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AEON COMMERCIAL INDIA PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AERO BASED CONTROL SYSTEMS PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12L21</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AGARWAL POLYPLAST</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11G26</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AGARWAL TEXTILE INDUSTRIES</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12D4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AIRJET INDIA</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AK TECHNOFAB</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AKSONS ENGINEERING LLP</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10G9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ALEETEX(CHINA)TECHNOLOGY CO.,LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>
                                                                All India Cotton Farmer Producer Organization
                                                                Association
                                                            </td>
                                                            <td />
                                                            <td>H11</td>
                                                            <td>H11H30</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ALT</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AM INNOSPIN SYSTEMS PVT. LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9E1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AMAR JACQUARD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15D24</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AMBA PROJEX</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AMRITLAKSHMI MACHINE WORKS</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A31</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ANDRITZ ASSELIN – THIBEAU S.A.S</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12A22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ANDRITZ KUSTERS GMBH</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12A22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ANDRITZ LAROCHE S.A.S.</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12A22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>
                                                                ANDRITZ PERFOJET SAS/ANDRITZ TECHNOLOGIES PRIVATE
                                                                LIMITED
                                                            </td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12A22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ANJNEY TUBES INDIA</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>APPLIED AUTOMATIONS SYSTEMS PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9G2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>APSOM TECHNOLOGIES (INDIA) PVT. LTD</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7</td>
                                                            <td>H7L1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ARISE IIP INDIA PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E23</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ARTEK MALIPLAST</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ARUN TEXTILE ENGINEERS PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J21</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ASAWA INSULATION PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10G17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ASHTON INTERNATIONAL PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ASOCIACION MULTISECTORIAL DE EMPRESAS - AMEC</td>
                                                            <td>SPINNING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ASPIRE GRAND EXCEL AUTOMATION</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E28</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ATLAS SINKER &amp; NEEDLE</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H14</td>
                                                            <td>H14J1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AUGEAN ENTERPRISE SOLUTIONS PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5H5A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AUSTRO CHEMICALS &amp; BIO-TECHNOLOGIES PVT.LTD.,</td>
                                                            <td>DYESTUFF CHEMICAL</td>
                                                            <td>H7A</td>
                                                            <td>H7AA18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AUTOMHA S.P.A.</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15D13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AUTOTEX PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12C23</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AVC INDUSTRIAL SALES PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H5</td>
                                                            <td>H5F10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AVC INDUSTRIAL SALES PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>AVC Industrial Sales Private Limited</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>B R SPECIALITIES LLP</td>
                                                            <td>DYESTUFF CHEMICAL</td>
                                                            <td>H5</td>
                                                            <td>H5G5H6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>B.TEX INDIA</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10E15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BAJAJ INDUSTRIES PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12G39</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BAKUBHAI AMBALAL (ORIENTAL ENTERPRISE)</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7M2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>BALDWIN JIMEK AB</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AB9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>BALKAN TEKSTIL MAKINA A.S.</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10G15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>BANGLADESH TEXTILE JOURNAL</td>
                                                            <td />
                                                            <td>H10</td>
                                                            <td>H10F21</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BANTHIA CONSULTANCY</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15D12E11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>BARIS YEDEK PARCA TIC. VE SAN. LTD. STI.</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BASANT WIRE INDUSTRIES PVT. LTD.,</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11C24</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BATLIBOI LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BATLIBOI LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11B19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BAUMER INDIA PVT. LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BEA ELECTRONICS</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12L6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>BEAUJADY TRADING CO.,LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>BEIJING CHONGLEE MACHINERY CO.,LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12L8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BELTECH INDIA INC.</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10E9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BELTING ENTERPRISES PVT.LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11G32</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                BENEKS TAAH. MUH. MUM. MAK. SAN. VE TIC. LTD. STI.
                                                            </td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3C10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BENNINGER INDIA PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3C1D2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BEST IMPEX</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A21</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BESTOMECH INDUSTRIES</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9G5A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BHAGAT MACHINES PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12F33G36</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BHAGAT TEXTILE ENGINEERS</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12F33G36</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BHAGYAREKHA ENGINEERS PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7P13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BHARAT BEAMS PRIVATE LIMITED</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BHARAT MACHINES</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12H45</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BHATT BROS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1B9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>BIANCO S.P.A.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F16A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BIANCO TEXTILE SOLUTIONS INDIA PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A3B4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BLUDIGIT TECHNOLOGIES </td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H5</td>
                                                            <td>H5G15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BLUDIGIT TECHNOLOGIES </td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H5</td>
                                                            <td>H5G15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BLUE MOON MACHINES MFG.CO.</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>BMK BIRLIK MAKINA KALIP SAN. VE TIC.LTD.STI.</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11G25</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BOMBINO</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3E9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BRÄCKER AG</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>BRAZZOLI SRL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3C14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BRUECKNER TEXTILE TECHNOLOGIES</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>B-TEX TEXTILE MACHINERY</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>BUSI GIOVANNI SRL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>CALLEBAUT DE BLICQUY</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G1H2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>CANLAR MEKATRONIK SAN. VE TIC A.S.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CANSPIN INDUSTRIES</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F34</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CARL BECHEM LUBRICANTS INDIA PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10H17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CENTURY INKS PRIVATE LIMITED </td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>CHANGZHOU JINERL CARPET MACHINE PARTS CO., LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H7A</td>
                                                            <td>H7AE8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                CHANGZHOU RUNFENGYUAN TEXTILE MACHINERY MANUFACTURING
                                                                CO.,LTD
                                                            </td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15D17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                CHANGZHOU TIAN HUANG WARP KNITTING TECHNOLOGY CO.,LTD
                                                            </td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15E24</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>CHANGZHOU UBER TEXTILE CO.,LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12G38</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CHEMAX MULTIKOTES (INDIA) PVT LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E27A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CHEMIN ENVIRO SYSTEMS PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3C4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CHICAGO BLOWER (INDIA) PVT. LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E33</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>CHINA TEXMATECH CO., LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CHIVEN SPINNING</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10A8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CHOLA TRADE B2B TEXTILE</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E30</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CIMA SRI AIRJET SPARES</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CITYTEX CORPORATION</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E27</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>COIMBATORE AIR CONTROL SYSTEMS PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10B11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>COIMBATORE MACHINE WORKS</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14F2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>COLORJET INDIA LIMITED</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H5</td>
                                                            <td>H5F3G4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>COMEZ INTERNATIONAL S.R.L.</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C8D7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>COMTEX ENGINEERING ( BOMBAY ) PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A3B4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CONDAIR</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CONER INTERNATIONAL PVT LTD </td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12F43</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CONFEDERATION OF INDIAN TEXTILE INDUSTRY</td>
                                                            <td />
                                                            <td>H11</td>
                                                            <td>H11H24A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>COPOWER TECHNOLOGY CO. LTD.</td>
                                                            <td>DYESTUFF CHEMICAL</td>
                                                            <td>H7A</td>
                                                            <td>H7AB8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>CORINO MACCHINE SPA</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A1B2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CORPORA CONSULTANTS PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AB14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CORPORATE CONSULTANTS</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9G5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>COTTON EGYPT ASSOCIATION </td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12L20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>Craftsman Automation Limited</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A1B2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CST COLOUR SCANNER TECHNOLOGY GMBH </td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H5</td>
                                                            <td>H5G15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>CUBOTEX SRL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>
                                                                D.K.T.E.SOCIETY'S TEXTILE &amp; ENGINEERING INSTITUTE
                                                            </td>
                                                            <td />
                                                            <td>H10</td>
                                                            <td>H10H13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>DAELIM STARLET CO.,LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>DANITECH ENGINEERING AND SOLUTIONS SRL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DARSHANA INDUSTRIES PRIVATE LIMITED</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15D26E31</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>DATACOLOR ASIA PACIFIC (HK) LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5J7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DATALOG TECHNOLOGIES P. LTD.,</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DATATEX</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5H7J8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DCC PRINT VISION LLP</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H5</td>
                                                            <td>H5F1G2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>DENT INSTRUMENTATION LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9G6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DEPARTMENT OF ATOMIC ENERGY</td>
                                                            <td />
                                                            <td>H11</td>
                                                            <td>H11H25</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DETTIN S.P.A</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DETTIN S.P.A.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DFU PUBLICATIONS </td>
                                                            <td />
                                                            <td>H10</td>
                                                            <td>H10H18A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DHARA ENGINEERING WORKS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DHARA ENTERPRISE </td>
                                                            <td>
                                                                HOME TEXTILE, INTEGRATED TEXTILE PARK, TECHNICAL TEXTILE
                                                            </td>
                                                            <td>H15</td>
                                                            <td>H15E6A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DHARAM TRANS BELTS</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DIANA DYEING ENGINEERS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7L12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>DILO SYSTEMS GMBH</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12B23</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DIVY ARROWTEX (SISTER CONCERN OF PRAPTI TEXCO)</td>
                                                            <td>
                                                                HOME TEXTILE, INTEGRATED TEXTILE PARK, TECHNICAL TEXTILE
                                                            </td>
                                                            <td>H15</td>
                                                            <td>H15C19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DN ASSOCIATES</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12A22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DRAFT AIR INDIA PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E33</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DUPONT MOLYKOTE</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7P3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DUPONT™ ARTISTRI® DIGITAL INKS</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7</td>
                                                            <td>H7P1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DUPONT™ ARTISTRI® DIGITAL INKS</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7</td>
                                                            <td>H7P1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DYNAMIC AUTOLOOMS INDIA PVT. LTD.</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DYNAMIC TEXTILE ENGINEERS</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9G3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>DYNAVAC INDIA PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12D3E30</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>EASTERN ENGINEERING COMPANY</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G1H2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>EASTLAND PUBLICATIONS PVT. LTD(TEXTILE TRENDS)</td>
                                                            <td />
                                                            <td>H11</td>
                                                            <td>H11H35</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>
                                                                ECK HAUBOLD &amp; LAXMI (UNIT OF HINDOOSTAN MILLS LTD)
                                                            </td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>EEPC INDIA</td>
                                                            <td />
                                                            <td>H10</td>
                                                            <td>H10H15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>EFFEDI MECCANOTEK S.R.L</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>EHWHA GLOTECH CO., LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AB5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ELECTRO JET MACHINERY (PVT) LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11C19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ELESA AND GANTER INDIA PVT. LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7L7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ELGI ELECTRIC AND INDUSTRIES LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10B7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ELGI ULTRA LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ELIAR ELEKTRONIK SAN. A.S.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ELTEKSMAK ELK.ELT.MAK.SAN.TIC.LTD.STI.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H12</td>
                                                            <td>H12H37</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>EMBEE CORPORATION</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5H9J10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>EMINENCE MACH TECH</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15C17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>EMS MACHINES GLOBAL INDIA PVT. LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>EMTEC ELECTRONIC GMBH</td>
                                                            <td>DYESTUFF CHEMICAL</td>
                                                            <td>H7A</td>
                                                            <td>H7AA10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ENES MAKINE EDN.SAN.TIC.LTD.STI</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G1H2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                ENMOS ENDUSTRIYEL OTOMASYON ELEKTRONIK IMALAT SAN. TIC.
                                                                A.S.
                                                            </td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7L4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ENVIRON</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G1H2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ERBATECH MACHINERY PVT. LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3D5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ERHARDT + LEIMER (INDIA) PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1B3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ESSR ELECTRONIC JACQUARD MANUFACTURING COMPANY</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14F2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>EURASIA TEMAC PVT. LTD.</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>EUROPROGETTI S.R.L.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>EUROTECH TECHNICAL SOLUTIONS P LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3C6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>FERRARI EASTERN FANS INDIA PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12E35</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>FERRARI EASTERN FANS INDIA PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12E35</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>FERRARO SPA</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>FIBRE2FASHION PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12F42</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>FIBRE2FASHION PVT. LTD.</td>
                                                            <td />
                                                            <td>H12</td>
                                                            <td>H12F42</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>FILCO TRADE CENTRE PVT LTD </td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>FIMAT S.R.L.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>FORBO SIEGLING MOVEMENT SYSTEMS INDIA PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>FOSHAN SANSHUI YINGJIE PRECISION MACHINERY CO LTD</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>FOURWENTS ENGINEERING COMPANY</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G1H2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>FOURWENTS GROUP</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G1H2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>FRANSTEK BELTS PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F9G10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>FRESA FASHION</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H3</td>
                                                            <td>H3E8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>FUKAHAMA MACHINERY CO., LTD</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H14</td>
                                                            <td>H14B8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>FUTAI MACHINERY CO.,LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12D8A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>G.D. ENTERPRISES</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A29</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>G.G. SALES CO.</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11C22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GAINERS CONTROL</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9E10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GANDHI AUTOMATIONS PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7AB11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GARG ENGINEERS</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11C22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GARG ENTERPRISES</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11C22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GARGO CORPORATION</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GARNETT WIRE LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F23</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GAYATRI TEXTILE MACHINES</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9C1A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GAYATRITEX ENGINEERS PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3D9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>GERON CARDING CLOTHING (JIANGSU)CO.,LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11B15C18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GLOBAL SOFTWARES</td>
                                                            <td>
                                                                HOME TEXTILE, INTEGRATED TEXTILE PARK, TECHNICAL TEXTILE
                                                            </td>
                                                            <td>H5</td>
                                                            <td>H5F12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GLOBAL TECHNOCRATS INC</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10G22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GRAF + CIE AG</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GRAUTE GMBH</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12E35</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GROZ-BECKERT ASIA PVT. LTD. </td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A4B3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>GUALCHIERI E GUALCHIERI &amp; C. SRL</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9E8A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>GUMMI FAB INDUSTRIES</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7L6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>HABASIT INDIA PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9E5F6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>HAIJIA AIRJET AND WATERJET LOOMS</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15D15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>HARISH TEXTILE ENGINEERS LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A3B4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>HAWA ENTERPRISES</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7L14A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>HEBERLEIN AG</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>HEMTEX ENTERPRISES</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>HERZOG GMBH</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15C19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>HIMSON ENGINEERING PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12C21</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>HIMSON INDUSTRIAL CERAMIC PVT.LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11G30</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>HINDTEX INDUSTRIES</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>HI-TECH APPARATUS PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>HIWIN TECHNOLOGIES CORP.</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9F1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>HONGSAM DIGITAL SCIENCE&amp;TECHNOLOGY CO.,LTD</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7</td>
                                                            <td>H7N14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>HUAI'AN TIANMA TEXTILE MACHINERY CO., LTD.</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>HUAI'AN TIANMA TEXTILE MACHINERYCO.,LTD</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>HYPER FILTERATION PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5H1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>I SHREE ENGINEERING WORKS</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A25</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>IDEAL SHEET METAL PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9A2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>IDEALIN FOGGING SYSTEMS</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>IGUS INDIA PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H12</td>
                                                            <td>H12L18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>IL SUNG MACHINERY CO. LTD </td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>INARCO PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12B21C26</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>
                                                                INDIAN TEXTILE ACCESSORIES AND MACHINERY MANUFACTURERS'
                                                                ASSOCIATION (ITAMMA)
                                                            </td>
                                                            <td />
                                                            <td>H9</td>
                                                            <td>H9H8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>INDIAN TEXTILE JOURNAL</td>
                                                            <td />
                                                            <td>H12</td>
                                                            <td>H12H41</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>INDIANA TECHNICAL CERAMICS </td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10E14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>INDO POLISH CHAMBER OF COMMERCE &amp; INDUSTRY</td>
                                                            <td />
                                                            <td>H11</td>
                                                            <td>H11H25A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>INDO TEXNOLOGY P LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>INDOEURO ENGINEERING LLP</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A3B4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>INDUS ELECTRONICS INDIA PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11G29</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>INDUSTRIAL BOILERS LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5J13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>INDUSTRIAL ELECTRONICS CORPORATION</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11G21</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>INNOVA ENTERPRISE</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15H5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>INNOVATIVE MEDIA AND INFORMATION COMAPNY</td>
                                                            <td />
                                                            <td>H10</td>
                                                            <td>H10H21</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>INOWEAVE</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>INSPIRON ENGINEERING PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10A10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>INSPIRON ENGINEERING PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3C2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>Intex Consulting Group </td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ISC TEX -TECH PVT LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9H5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ISOTEX CORPORATION PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ITALIAN TEXSTYLE</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11B17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ITEMA S.P.A</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C6D5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ITEMA WEAVING (INDIA) PVT LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C6D5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>J. SCHLENTER PRODUCTION GMBH</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JACOBI MACHINERY PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12A15B20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JACQUARD HARNESS CORD PRIVATE LIMITED</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E32</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JAI ASHAPURA HYDRAULICS </td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12D5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JAI GRAPHITECH CO</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JAKOB MUELLER (INDIA) PRIVATE LIMITED</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C8D7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>JAKOB MUELLER AG</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C8D7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JANATICS INDIA PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F27G28</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JAY DADA INDUSTRIES </td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JAY INSTRUMENTS AND SYSTEMS PRIVATE LIMITED</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7</td>
                                                            <td>H7L5N8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JAYANTILAL S GANDHI &amp; CO ( MACH DIV) </td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JAYSYNTH DYESTUFF (INDIA) LIMITED</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7</td>
                                                            <td>H7L5N8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JC METAL FAB</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10B10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>JEANOLOGIA S.L.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JECKSWELL MACHINERY PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JETSTAR INNOVATIONS (P) LTD</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7</td>
                                                            <td>H7N5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JEYALETSHMI MACHINE WORKS</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12E37</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>JIANG SU HAIDA TEXTILE MACHINERY CO.,LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7L9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>JIANGSU YINGYANG NONWOVEN MACHINERY CO LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E25</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                JIANGYIN DESEL ENVIRONMENTAL PROTECTION EQUIPMENT CO.,
                                                                LTD.
                                                            </td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12D8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                JIANGYIN HUAFANG NEW TECHNOLOGY AND SCIENTIFIC RESEARCH
                                                                CO.,LTD
                                                            </td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12L16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>JIANGYIN MEJART COLORT FIBERCO.,LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9H9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JINDAL RECTIFIERS</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JINKOSOLAR TRADING PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC24</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JOGINDRA INDUSTRIES PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JUMAC MANUFACTURING PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9B1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JUPITER CERAMICS</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11H28</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>JUPITER COMTEX PRIVATE LIMITED</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C12D11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>K M ASSOCIATES</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9B3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>K TEX INDIA</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14H3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KAILASH TEXTECH SOLUTION</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KAISHAN MACHINERY INDIA PRIVATE LIMITED</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KAPURTHALA HI-TECH TRANSBELT PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10G18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KARL MAYER TEXTILE MACHINERY INDIA PVT. LTD.</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15C10D9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>KAVURLAR MAKINA SAN VE TIC A.S</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11G24</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KAYEMESS MARKETING</td>
                                                            <td>DYESTUFF CHEMICAL</td>
                                                            <td>H7A</td>
                                                            <td>H7AA8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KCI BEARINGS (INDIA) PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12B26</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>KERN LIEBERS KNITTING PARTS</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15C16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KEY TEXTILE ACCESSORIES PVT LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KHODIYAR TEXTILE INDUSTRIES</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KHUSH OVERSEAS</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H1</td>
                                                            <td>H7B7A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>KINEX BEARINGS, A.S.</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10H18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KIRLOSKAR PNEUMATIC COMPANY LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KIRLOSKAR TOYOTA TEXTILE MACHINERY PVT LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C2D1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KISCO INDIA PRIVATE LIMITED</td>
                                                            <td>DYESTUFF CHEMICAL</td>
                                                            <td>H1</td>
                                                            <td>H1B1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KLUBER LUBRICATION INDIA PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9C1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KOERTING ENGINEERING PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5J4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KONICA ELECTRONICS ENTERPRISE</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15F12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KOTHARI TECHNO TEX</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14H1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KRISHNA ENGINEERING</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KRISTEEL- SHINWA INDUSTRIES LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E26</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KROSSMARK INNOVATIONS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5H9J10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KRSNA ENGIMECH PVT.LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KRSNA ENGINEERING WORKS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KTM KRANTZ TEKNIK MAKINA IMALAT TIC. A.S.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>KUIL MACHINERY INDUSTRY CO.,LTD.</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KUNJ NEEDLES INDUSTRIES</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>KUNTAI MACHINERY CO.,LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5J9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>KUSTERS CALICO MACHINERY PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3E15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>L.G.L. ELECTRONICS S.P.A</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LAFER SPA </td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3E1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LAKHOTIA ENTERPRISE</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10H15A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LAKSHMI CARD CLOTHING MFG.CO.PVT.LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10A5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LAKSHMI CARD COPS TECHNO ENGINEERING</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F32</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LAKSHMI LIFE SCIENCES PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F31G34</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LAKSHMI MACHINE WORKS LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9A1B2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LAKSHMI MACHINE WORKS LIMITED-UNIT 2</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9A1B2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LAKSHMI PRECISION TECHNOLOGIES LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10B4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>
                                                                LAKSHMI RING TRAVELLERS (COIMBATORE) PRIVATE LIMITED
                                                            </td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10B9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LATHIA RUBBER MFG. CO. PVT. LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7P9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LAWER S.P.A</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5H3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LAXMI SHUTTLELESS LOOMS PVT LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LAXMI TEX ENGINEERSS</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7A</td>
                                                            <td>H7AB13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LAXMI TEXTILE PRODUCTS</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F26</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LAXMI TEXTILE STORES</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LEEWHA SRC. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11H35A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LENZE MECHATRONICS PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7P17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LENZING INSTRUMENTS GMBH &amp; CO. KG</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9C6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LEO RUBBER INDUSTRIES </td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5J3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LEUZE ELECTRONIC GMBH + CO. KG</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F24</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LEUZE ELECTRONIC PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F24</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LIANYUNGANG RUNIAN INDUSTRIAL CO.,LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LIFEBOND MACHINES PVT.LTD.</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LINDAUER DORNIER GMBH</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A27</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LOEPFE BROTHERS LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H14</td>
                                                            <td>H14A2B1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LOGIC ART AUTOMATION CO. LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3C8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LONATI SPA</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15D18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LONGKOU SUNNY MOULDING CO.,LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LONGMAN KNIT PARTS MFG CO.</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15D4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LOPTEX SRL</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11B17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LORIS BELLINI SRL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>LUBRICANT CONSULT GMBH</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10H14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LUTHRA PNEUMSYS</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11H35B</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>LUWA INDIA PVT. LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11A16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>M.R. LABELS CO.</td>
                                                            <td>
                                                                HOME TEXTILE, INTEGRATED TEXTILE PARK, TECHNICAL TEXTILE
                                                            </td>
                                                            <td>H7A</td>
                                                            <td>H7AC9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>MACHINERY EXPORTERS' ASSOCIATION</td>
                                                            <td>
                                                                HOME TEXTILE, INTEGRATED TEXTILE PARK, TECHNICAL TEXTILE
                                                            </td>
                                                            <td>H7A</td>
                                                            <td>H7AB2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MAG SOLVICS PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10E11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MAG SOLVICS PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5J2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>Mageba International GmbH</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MAHALAXMI MILL STORE COMPANY</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9C4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MAKSTEEL WIRE HEALDS PRIVATE LIMITED</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MANGAL SINGH BROS PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10E7F8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MANIAR RUBBER INDUSTRIES</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7</td>
                                                            <td>H7L14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MANOJ ENGINEERING</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MANVI TEXTILE AIR ENGINEERS PVT.LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12C26</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>MARIO CROSTA SRL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>MARKETO SERVICES</td>
                                                            <td />
                                                            <td>H12</td>
                                                            <td>H12G37</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>
                                                                MARZOLI TEXTILE MACHINERY MANUFACTURERS PRIVATE LTD
                                                            </td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11C17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MATEX GLOBAL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3E3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MATHIS INDIA PVT. LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3E11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>MAYER &amp; CIE. GMBH &amp; CO. KG</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MAYUR REEDS AND HEALDS PVT. LTD.</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MCS OFFICINA MECCANICA SPA</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MEC GROWTHS TEXMACH PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9F7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MEERA INDUSTRIES LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12L12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MEHRA WAX PRODUCTS PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9H5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                MENGZHOU HELI TEXTILE ELECTRICAL APPLIANCE CO.,LTD
                                                            </td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E23</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MENZEL ENGINEERING INDIA PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A3B4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>MESDAN S.P.A.</td>
                                                            <td>SPINNING</td>
                                                            <td>H14</td>
                                                            <td>H14A2B1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>METSA MAKINE VE METAL SAN. TIC. LTD. STI.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>MHMS MECHATRONIC SOLUTIONS GMBH &amp; CO. KG</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7A</td>
                                                            <td>H7AE4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MICROCHEM</td>
                                                            <td>DYESTUFF CHEMICAL</td>
                                                            <td>H3</td>
                                                            <td>H3D6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MICROTEX ENERGY PRIVATE LIMITED</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15J7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MIKHAIL ENTERPRISES</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7</td>
                                                            <td>H7L3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MILLWRIGHT ENGINEERING PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12F43</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MILVUS TEKNOLOJI MEKATRONIK</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>Ministry of Textiles, Govt.of India </td>
                                                            <td />
                                                            <td>H7A</td>
                                                            <td>H7AC15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MOHLER MACHINE WORKS PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MOKSHA THERMOPLASTICS PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9F2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MONGA STRAYFIELD PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MONTI ANTONIO S.P.A </td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MRL PRINTING ROLLS PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MRS BEARINGS PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MS PRINTING SOLUTIONS SRL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MSB CONSULTING PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MSB CONSULTING PVT LTD</td>
                                                            <td>
                                                                HOME TEXTILE, INTEGRATED TEXTILE PARK, TECHNICAL TEXTILE
                                                            </td>
                                                            <td>H3</td>
                                                            <td>H3C7D12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>MURATA MACHINERY, LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11A13B18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>MURATA MACHINERY, LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11A13B18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MUVTONS CASTORS PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12C27</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MY Q ENGINEERING PVT LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>MYLON METALLICS P LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>N P KINARIWALA PVT LTD </td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F30</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>N. KANTILAL &amp; CO</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>N.P. BELTING PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10H20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NANOTEK CONTROLS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7L13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NARAYAN OIL &amp; GAS BURNERS CO.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NAREN TEXTILE ENGINEERS INDIA PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12C30</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NARINDER INTERNATIONAL</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H14</td>
                                                            <td>H14B14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NEEDLES AND ELEMENTS INDIA PVT LIMITED</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15D2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NEELKANTH TEXTILE INDUSTRIES</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12F45</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NESTLING TECHNOLOGIES INDIA PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>NEUENHAUSER MASCHINENBAU GMBH</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11A18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NEW VISION GLOBAL INDUSTRIES PRIVATE LIMITED</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14J3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NIFT MUMBAI</td>
                                                            <td />
                                                            <td>H11</td>
                                                            <td>H11H22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NIKKA RAM SUIAN WALA</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15C15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NITTA CORPORATION INDIA PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12B24</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NITTO SHOJI LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>NIUPAI TEXTILE MACHINERY CO.,LTD JIANGSU,CHINA</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14H2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NMTRONICS INDIA PVT LTD </td>
                                                            <td>
                                                                HOME TEXTILE, INTEGRATED TEXTILE PARK, TECHNICAL TEXTILE
                                                            </td>
                                                            <td>H7A</td>
                                                            <td>H7AC14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NOVA INTER TECH CO.,LTD.</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H5</td>
                                                            <td>H5G15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NOVIBRA</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>NPS DRIVE AUTOMATION PVT. LTD.</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E29</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                ODESI TEKSTIL BILGISAYAR MAKINA INSAAT SAN. TIC. LTD.
                                                                STI.
                                                            </td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A3B4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                OERLIKON BARMAG ZWEIGNIEDERLASSUNG DER OERLIKON TEXTILE
                                                                GMBH &amp; CO. KG
                                                            </td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11C15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>OKOSU CERATECH PVT LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>OM CORPORATION</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>OM TECHNOTEX INDUSTRIES</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12B25</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>OM TEXTILE SOLUTION</td>
                                                            <td>
                                                                HOME TEXTILE, INTEGRATED TEXTILE PARK, TECHNICAL TEXTILE
                                                            </td>
                                                            <td>H7</td>
                                                            <td>H7P5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ORANGE O TEC PVT LTD</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ORBIT INSTRUMENTS</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12E34</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>OSWAL TRADERS </td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10H15B</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>P MECH ENGINEERS</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7</td>
                                                            <td>H7P15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PALOD HIMSON MACHINES PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12L4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PARAMOUNT INSTRUMENTS P LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PARAS HEALDS AND REEDS PVT LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E28</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PATEL ENGINEERS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7P4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PEASS INDUSTRIAL ENGINEERS PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>PENTEK TEXTILE MACHINERY SRL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PERFECT ENGINEERING CORPORATION</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10A7B12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PERFECT ENGINEERS</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10A7B12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PERFECT EQUIPMENTS PVT.LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10A7B12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PERFECT TEXTILE SOLUTIONS</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15F10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>PICANOL INDIA</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A6B5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PINTER FA.NI ASIA PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11B16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PIOTEX VENTURES PRIVATE LIMITED</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>PLEVA GMBH</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5H11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PLM IMPIANTI</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>POLYTEX CHEMICAL ENGINEERING CO., LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9F3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>POOJA ENTERPRISES</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AB1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>POOJA ENTERPRISES </td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>POWER BELT INDIA</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9F5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>POZZI LEOPOLDO SRL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PR TEXPRO ENGINEERING </td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12B25</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PRABHAT TEXTILE CORPORATION</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3D3E4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PRANSHI ENGINEERS</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15D28</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>PRAPTI TEXCO</td>
                                                            <td>SPINNING</td>
                                                            <td>H12 </td>
                                                            <td>H12A21</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PRAPTI TEXCO</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15C19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PRAPTI TEXCO</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15C19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PRASHANT FERBER LOGISTIC AUTOMATION PVT. LTD.</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C4D3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PRASHANT GAMATEX PVT. LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C4D3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PRASHANT WEST POINT MACHINERY PVT. LTD.</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C4D3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PRECISION PLASTICS CORPORATION</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10G9A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PRECISION RUBBER IND. PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11B14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PREMIER COLORSCAN INSTRUMENTS PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7P7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PREMIER EVOLVICS PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12A17B22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PRISM TEXTILE MACHINERY</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>PROSINO S.R.L.</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J23</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>PROSMH MAKINA PAZARLAMA SAN. VE TIC. A.S.</td>
                                                            <td>WEAVING</td>
                                                            <td>H1</td>
                                                            <td>H1A8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PROSMH MAKINA PAZARLAMA SAN. VE TIC. A.S.,</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PUGI GROUP SRL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>PUJA TEXTILE INDUSTRIES</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F36</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>PUM INTERNATIONAL LIMITED</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A26</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>QINGDAO KERUN BIO-TECHNOLOGY CO. LTD</td>
                                                            <td>DYESTUFF CHEMICAL</td>
                                                            <td>H7A</td>
                                                            <td>H7AC1A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                QINGDAO ORIENT TIANCHANG IMPORT&amp;EXPORT CO.,LTD
                                                            </td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E25</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>R. B. ELECTRONIC &amp; ENGINEERING PVT. LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>R. K. SEWING MACHINES</td>
                                                            <td>
                                                                HOME TEXTILE, INTEGRATED TEXTILE PARK, TECHNICAL TEXTILE
                                                            </td>
                                                            <td>H7A</td>
                                                            <td>H7AA22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>R.K.TEXPARTS </td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15F11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>RABATEX INDUSTRIES</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A8B7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>RAMANA MACHINES</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15C14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>RAMESHWAR ENGINEERING</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H5</td>
                                                            <td>H5J6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>RAMP IMPEX PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7L1A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>RATERA SA</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15D22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>RATTI LUINO SRL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>RAUSCHERT HEINERSDORF-PRESSIG GMBH</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10G13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>RE EQUIPMENTS (INDIA) PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>REGENT MACHINE &amp; SERVICING</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>REGGIANI MACCHINE SPA</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H3</td>
                                                            <td>H3C3D4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>REIFENHÄUSER ENKA TECNICA GMBH</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>RESHMI INDUSTRIES (INDIA) PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10B5C8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>RIETER INDIA PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>RIGAMONTI E PEREGO E C. SRL </td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>RIMA MACHINES PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10B10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>RIMTEX INDUSTRIES</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10A12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>RISHABH SAGAR TEXTILE EQUIPMENTS PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12F41</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>RMP BEARINGS LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12G44</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ROJ ELECTROTEX SRL</td>
                                                            <td>SPINNING</td>
                                                            <td>H14</td>
                                                            <td>H14A2B1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>RONSON INDUSTRIAL ENGINEERS PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A3B4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ROOPA SCREEN PVT LTD</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H5</td>
                                                            <td>H5F4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ROTORCRAFT AG</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>S R PLASTIC INDUSTRIES</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>S S TEXTILE MEDIA PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12E41</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SABAR MACHINE TOOLS MFG CO</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11A14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SAHAI AUTOMATION</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SAIL NONWOVEN MACHINERY CO.,LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9H4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SAINIT EXPORTS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SALVADE SRL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SALVADE SRL -KMT ABRANCH OF SALVADE</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SANDO TECH, INC.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SANJAY PLASTICS &amp; INDUSTRIAL SERVICES</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SANTEX RIMAR GROUP</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SANTONI S.P.A.</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15D20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SAPRU MACHINES PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12L1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SARACHEM INDIA PVT LTD</td>
                                                            <td>DYESTUFF CHEMICAL</td>
                                                            <td>H7A</td>
                                                            <td>H7AC7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SAROJA TEXCONE</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11H27</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SAURER (CHANGZHOU) TEXTILE MACHINERY CO. LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C7E12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SAURER FIBREVISION LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C7E12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SAURER SPINNING SOLUTIONS GMBH &amp; CO KG</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C7E12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SAURER SPINNING SOLUTIONS GMBH &amp; CO. KG</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C7E12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                SAURER TECHNOLOGIES GMBH &amp; CO. KG TWISTING SOLUTIONS
                                                            </td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C7E12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SAVIO MACCHINE TESSILI S.P.A.</td>
                                                            <td>SPINNING</td>
                                                            <td>H14</td>
                                                            <td>H14A2B1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SAVIO TEXCONE PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12F37</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SB DYESPRINGS(INDIA)PVT.LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3E7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SCREEN-O-TEX (INDIA) PVT LTD</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H5</td>
                                                            <td>H5G7H8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SCREENOTEX ENGINEERS PVT. LTD.</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7</td>
                                                            <td>H7P2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SEDO ENGINEERING SA </td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1B5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SEDO TREEPOINT GMBH</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1B5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>Seiren Electronics Co., Ltd.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SEMITRONIK INSTRUMENTS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SEPSON TEXTILE MACHINES</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F29</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SERTEKS TEKSTIL MAKINALARI SAN. LTD. STI.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7P11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SERVO POLYTECH COIMBATORE (P) LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11G23</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SETEX SCHERMULY TEXTILE COMPUTER GMBH</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7L8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHAKTI TEXTILE TRADERS</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHAMOTS INTERNATIONAL</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14G2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SHANDONG RIFA TEXTILE MACHINERY CO.,LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14F6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                SHANGHAI CHAOCHENG ELECTRON SCIENCE AND TECHNOLOGY
                                                                CO.,LTD
                                                            </td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B22 </td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                SHAOXING CITY YUECHENG DISTRICT YINGXIANG TEXTILE
                                                                MACHINERY CO.,LTD
                                                            </td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHARMAN MECHANICAL WORKS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHARNAM TEX INDIA PVT LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHEEBA ENTERPRISE</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3D7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHELTRONICS CONRTOL SYSTEMS PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SHENGLEI(SUZHOU)TRANSMISSION MATERIAL CO.,LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10H12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHIMA SEIKI MFG., LTD., JAPAN</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHIMATO ENTERPRISES PVT. LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AB16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHINE TEX ENGINEERS</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12E39</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHIV SHAKTI ENGINEERING</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHIVAM ENGINEERING AND FABRICATION WORKS</td>
                                                            <td>SPINNING</td>
                                                            <td>H15</td>
                                                            <td>H15E5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHOBAPRAD MACHINERY LLP</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H14</td>
                                                            <td>H14B15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHREE BRHM CORPORATION</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHREE CHAMUNDA ENTERPRISE</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHREE KRISHNA SALES</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9G7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHREE MAHAVEER TEXTILE STORES</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15D6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHREE PRAMUKH ENTERPRISE</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14J2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHREE RAM TEXTILE</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHREE SAANVI ENTERPRISE</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14F4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHREE TEX CORPORATION</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E27</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHREENATH TEXTILE ENGINEERS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A3B4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SHRUTEX INTERNATIONAL</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15D10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SIDDHI ENGINEERS</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10G14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SIEGER SPINTECH</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12A20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SILVERSTONE TECHNOLOGIES INDIA PVT LTD</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SILVERTOWN TEXTILE TRADING CO.</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SIMTA CLEAR COATS PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12A15B20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SIMTA MACHINERY PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12A15B20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SIMTA MANUFACTURING COMPANY</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12A15B20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SINGH KNITTING TOOLS</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15D8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SINTEX-BAPL LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AD4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SKAAT MACHINE WORKS INDIA PVT.LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9B3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SKF INDIA LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12L22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SKYAIRCOOLER</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3E13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SMART ROLL INDUSTRIES </td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SMART TEX</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E33</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SMEW TEXTILE MACHINERY PVT LTF</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12E32</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SOHAM ENGINEERS</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12D6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SOSSNA GMBH</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12E36</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SPARTAN ELECTRICALS</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10G20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SPEROTTO RIMAR S.R.L. </td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SPGPRINTS BV</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H3</td>
                                                            <td>H3C5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SPI EQUIPMENTS INDIA PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5J5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SPINDRAFT</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SPINHOLE</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E21F22</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SPINNING TEXTILES</td>
                                                            <td />
                                                            <td>H10</td>
                                                            <td>H10H10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SPINTEX IMPEX PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9E2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SPRY MEDIA </td>
                                                            <td />
                                                            <td>H11</td>
                                                            <td>H11H23</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SRE CORPORATION</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14F2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SRI LAKSHMI FIRE CONTROL</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10G16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SRI PRAKASHA ENTERPRISES</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9H6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SRI SAROJ ENTERPRISES</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SRI SASTHA TEXTILE ENGINEERING</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11H29</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SRM TECHNOLOGIES</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12G35</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SSM</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>STAEDTLER+UHL KG</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9H2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>STALMEC ENG. PVT LTD</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H1</td>
                                                            <td>H1B7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>STAR BELTING</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J2A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>STAR REEDS AND HEALDS</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A23</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>STATEX ELECTRONICS</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>STAUBLI INDIA PVT. LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>STENMECH ENGINEERING WORKS PVT.LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3D11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>STOVEC INDUSTRIES LIMITED (SPGPRINTS GROUP)</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H3</td>
                                                            <td>H3C5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUBAM PAPER AND BOARDS PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11C20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUBLITEX </td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUESSEN GMBH</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUGIURA KNITTING NEEDLE MFG. CO. LTD.</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15D14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUJINI MACHINES</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12F46</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUMANLAL J.SHAH &amp; CO</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10H16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUNSHINE ENGINEERING</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7L16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUNTEC ENERGY SYSTEMS</td>
                                                            <td>
                                                                HOME TEXTILE, INTEGRATED TEXTILE PARK, TECHNICAL TEXTILE
                                                            </td>
                                                            <td>H5</td>
                                                            <td>H5G11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SUNTECH INDUSTRIAL(INTERNATIONAL)LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7L2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUPER MACHINE WORKS PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9E3F4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUPERBA S.A.S.</td>
                                                            <td>SPINNING</td>
                                                            <td>H14</td>
                                                            <td>H14A2B1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUPERTEX INDUSTRIES</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11A9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SURYA MILLGIN STORES</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14J4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUSHIL ENTERPRISES</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUSMATEX MACHINERY</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14G1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUTRAN POLYMERS PVT. LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUVIN </td>
                                                            <td />
                                                            <td>H7A</td>
                                                            <td>H7AB15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>SUZUKI ROLLERS</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12B21C26</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>SWINSOL AG</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>T4 TEXULTANTS PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TANYA ENTERPRISES</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TARASVAT INDUSTRIAL ELECTRONICS</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TECCHNO QUALICON SOLUTIONS PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12B27</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TECH MECH ENGINEERS</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15F8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TECH SPHERE ENGINEERING PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12F38</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TECHNO ELECTRONICS &amp; INSTRUMENTS</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12B27</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TECHNOCRAFT TEXMACH PVT LTD.</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14B18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TECHNOWEB TEXTILE ENGINEERING PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9G1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TECNORAMA SRL</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TECOYA TREND</td>
                                                            <td />
                                                            <td>H10</td>
                                                            <td>H10F21A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TEMCO</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TERROT GMBH, GERMANY</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TEX TECH INDUSTRIES (INDIA) PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TEXCARE INSTRUMENTS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AB4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TEXFAB ENGINEERS (I) PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TEXFAB INDUSTRIES PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TEXLAB INDUSTRIES</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3D7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TEXO INDUSTRIES</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AB17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TEXONIC INDIA</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15D19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TEXPERT</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10A6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TEXSPARES MACHINE WORKS</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>TEXTECHNO HERBERT STEIN GMBH &amp; CO. KG</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9E8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TEXTILE MACHINERY MANUFACTURERS' ASSOCIATION (I)</td>
                                                            <td />
                                                            <td>H12</td>
                                                            <td>H12H36A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>TEXTILE-FUTURE.COM </td>
                                                            <td />
                                                            <td>H12</td>
                                                            <td>H12H41A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TEXTRONICS DESIGN SYSTEMS (I) PVT LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15J5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TEXWARE TECHNOLOGY</td>
                                                            <td>
                                                                HOME TEXTILE, INTEGRATED TEXTILE PARK, TECHNICAL TEXTILE
                                                            </td>
                                                            <td>H7A</td>
                                                            <td>H7AA16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>THAKER ENGG CO.PVT.LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>THAKORE EXPORTS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5F11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>THE BOMBAY SUBSCRIPTION AGENCY</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H3</td>
                                                            <td>H3E5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>THE GAURS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3C10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>THE INDIAN CARD CLOTHING CO LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F23</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>THE PERMASHRINK COMPANY</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5H10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>THE SOUTH INDIA TEXTILE RESEARCH ASSOCIATION</td>
                                                            <td>
                                                                HOME TEXTILE, INTEGRATED TEXTILE PARK, TECHNICAL TEXTILE
                                                            </td>
                                                            <td>H11</td>
                                                            <td>H11H27A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>THE SOUTHERN INDIA MILLS' ASSOCIATION</td>
                                                            <td />
                                                            <td>H10 </td>
                                                            <td>H10H21A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>
                                                                THE SYNTHETIC AND ART SILK MILLS' RESEARCH ASSOCIATION
                                                            </td>
                                                            <td />
                                                            <td>H10</td>
                                                            <td>H10H11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>THE TEXTILE ASSOCIATION (INDIA) - DELHI </td>
                                                            <td />
                                                            <td>H11</td>
                                                            <td>H11H24</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>THE YARN BAZAAR</td>
                                                            <td />
                                                            <td>H12</td>
                                                            <td>H12H36</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>THEMIS AUTOMATION PVT. LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>THIES GMBH &amp; CO. KG, GERMANY</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TIMES INTERNATIONAL</td>
                                                            <td />
                                                            <td>H11</td>
                                                            <td>H11H33</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>TMART CORGHI TEXTILE MACHINERY (SHANGHAI) LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>TMT MACHINERY</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11A13B18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>TOMSIC SRL</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12D7</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TONY ENGINEERINGS </td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3D14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TOSHIN KOGYO CO LTD. (ICHINOSE)</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TRADE4INDIA</td>
                                                            <td />
                                                            <td>H12</td>
                                                            <td>H12G37A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TRIDENT PNEUMATICS PVT LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TRIM ENGINEERING SERVICES</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11E29</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TRIMURTI AGENCIES</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10C9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TRINITY TOUCH PVT. LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AE2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TRUE COLORS IMPEX</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H3</td>
                                                            <td>H3E6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>TRUETZSCHLER GROUP SE</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10A3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TRUETZSCHLER INDIA PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10A3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TSI POWER PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12D11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>TSUDAKOMA CORP</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TTS INDIA INSTRUMENTS</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11H29A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>TVC MEDIA AND PROMOTION PVT LTD</td>
                                                            <td />
                                                            <td>H12</td>
                                                            <td>H12H43</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>UMARGAON TEXTILE MACHINERY PVT. LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>UNIMECH ENGINEERS PVT LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AA15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>UNIROLS AIRTEX</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12G41</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>UNISPIN CARD CLOTHING INDIA PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11H31</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>UNITECH TEXMECH PVT. LTD.</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10E17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>UNITED TEXTILE ACCESSORIES</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>UNITOP AQUACARE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5J12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>
                                                                UNIVERSAL MEP PROJECTS &amp; ENGINEERING SERVICES
                                                                LIMITED.{" "}
                                                            </td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>USHA INDUSTRIAL CORPORATION</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F18</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>USTER TECHNOLOGIES AG</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9C5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>UV HITECH PVT. LTD.</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15D13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>V.M.TRADERS</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15E26</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>VALVAN BALING SYSTEMS NV</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12E35</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VANDEWIELE SAVIO INDIA PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H14</td>
                                                            <td>H14A2B1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VANDEWIELE SWEDEN AB (IRO)</td>
                                                            <td>SPINNING</td>
                                                            <td>H14</td>
                                                            <td>H14A2B1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>VANDEWIELE-BEJIMAC SA </td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1B5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>VANDEWIELE-SAVIO INDIA PRIVATE LIMITED</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A2B1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VEE KAY ENTERPRISES</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H3</td>
                                                            <td>H3D10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VEEJAY FINEPLAST</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12G33</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VEEJAY LAKSHMI ENGINEERING WORKS LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9A4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>
                                                                VEERMATA JIJABAI TECHNOLOGICAL INSTITUTE (VJTI) MUMBAI
                                                            </td>
                                                            <td />
                                                            <td>H10</td>
                                                            <td>H10H17A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VEL PLAST</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11G27</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VERODATATEX INDIA PRIVATE LIMITED</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5H7J8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VERTEX EDGE TECH</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15E10</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VETAL HITECH MACHINES PVT.LTD.,</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12A19</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VETRI ENGINEERS</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10G11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VIBRANT REEDS AND HEALDS</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C20</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VIKRAM ENGINEERING WORKS</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11H26</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VISISTA INDIA PRIVATE LIMITED</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VV HITECH INNOVATIONS INDIA PRIVATE LIMITED</td>
                                                            <td>
                                                                HOME TEXTILE, INTEGRATED TEXTILE PARK, TECHNICAL TEXTILE
                                                            </td>
                                                            <td>H11</td>
                                                            <td>H11H22A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>VXL SYSTEMS</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12L2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>WARP WEBSTERS PVT LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>WEAVE TEX ENGINEERS PVT LTD </td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AB12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>WEAVETECH ENGINEERS LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11B13C16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>WEITMANN &amp; KONRAD GMBH &amp; CO. KG</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5J1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>WESTERN TIN ROLL MANUFACTURING WORKS</td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9J4A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>WILLY INDIA PVT LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15D16</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>WIN TEX ENGINEERS INDIA PVT LTD </td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12F44</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>WINS SOFT INNOVATIONS PRIVATE LIMITED</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15J6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>WIRA INSTRUMENTATION LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12D9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>WORLD IMPEX INC, COMMUNION</td>
                                                            <td />
                                                            <td>H12</td>
                                                            <td>H12F45A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>WTT INTERNATIONAL PVT. LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AC4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>XETMA VOLLENWEIDER GMBH</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>XIAMEN RAPID PRECION MACHINERY CO.,LD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H1</td>
                                                            <td>H1A8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>X-RITE INDIA PVT LTD</td>
                                                            <td>DIGITAL PRINTING</td>
                                                            <td>H5</td>
                                                            <td>H5J11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>YAMUNA MACHINE WORKS LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H3</td>
                                                            <td>H3D1E2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                YANGZHOU ZHICHENG NEW FIBRE EQUIPMENT TECHNOLOGY CO.,LTD
                                                            </td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12L14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>YANTAI XINGYANG ELECTRONICS CO. LTD.</td>
                                                            <td>WEAVING</td>
                                                            <td>H14</td>
                                                            <td>H14A13</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>YARNCOMS OVERSEAS PVT LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H10</td>
                                                            <td>H10F17</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>YASH TEXTILE MACHINES PVT. LTD.</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7L11</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>YEMAN INDUSTRIES (HOLDINGS) LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H5</td>
                                                            <td>H5G1H2</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>Yilmak Makina San</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N7P6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>YIWU AURORA MACHINERY CO.,LTD</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15E15</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>YOGESH DEYSTUFF PRODUCTS PVT LTD</td>
                                                            <td>DYESTUFF CHEMICAL</td>
                                                            <td>H5</td>
                                                            <td>H5H12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>YOGESH DYESTUFF PRODUCTS (P) LTD.</td>
                                                            <td>DYESTUFF CHEMICAL</td>
                                                            <td>H11</td>
                                                            <td>H11A9</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>YUKSELIS YAYINCILIK LTD. STI.</td>
                                                            <td />
                                                            <td>H10</td>
                                                            <td>H10H22A</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ZEN INDUSTRIAL ENGINEERS</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7</td>
                                                            <td>H7N6</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ZENTEX SRL</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12F40</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NATIONAL</td>
                                                            <td>ZEON BELTS PVT LTD</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15C23</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ZHANGJIAGANG GANGYING INDUSTRY </td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9G8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ZHEJIANG KAICHENG INTELLIGENT MACHINERY CO.,LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11F28</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                ZHEJIANG BORETECH ENVIRONMENTAL ENGINEERING CO.,LTD.
                                                            </td>
                                                            <td>SPINNING</td>
                                                            <td>H9</td>
                                                            <td>H9G4</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ZHEJIANG HAIYING TEXTILE MACHINERY CO., LTD.</td>
                                                            <td>WEAVING</td>
                                                            <td>H15</td>
                                                            <td>H15E12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ZHEJIANG HONGXIN TECHNOLOGY CO.,LTD</td>
                                                            <td>KNITTING, EMBROIDERY, GARMENTING</td>
                                                            <td>H15</td>
                                                            <td>H15E14</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ZHEJIANG LIANKE MACHINERY CO.,LTD</td>
                                                            <td>PROCESSING</td>
                                                            <td>H7A</td>
                                                            <td>H7AB3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ZHEJIANG WANSHIFA TEXTILE MACHINERY CO.,LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12 </td>
                                                            <td>H12A21</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>ZHEJIANG YUFENG MACHINERY CO.,LTD</td>
                                                            <td>SPINNING</td>
                                                            <td>H12</td>
                                                            <td>H12D12</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                ZHENGZHOU ZHONGYUAN DRYING TECHNIQUE AND ENGINEERING
                                                                CO., LTD{" "}
                                                            </td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11G31</td>
                                                        </tr>
                                                        <tr>
                                                            <td>INTERNATIONAL</td>
                                                            <td>
                                                                ZHENGZHOU ZHONGYUAN DRYING TECHNIQUE AND ENGINEERING
                                                                CO.,LTD
                                                            </td>
                                                            <td>SPINNING</td>
                                                            <td>H11</td>
                                                            <td>H11G31</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(exhibitorsList));